import { render, staticRenderFns } from "./laboratory-process-grid.vue?vue&type=template&id=c2efa122&scoped=true&"
import script from "./laboratory-process-grid.ts?vue&type=script&lang=ts&"
export * from "./laboratory-process-grid.ts?vue&type=script&lang=ts&"
import style0 from "./laboratory-process-grid.scss?vue&type=style&index=0&id=c2efa122&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2efa122",
  null
  
)

export default component.exports